export const riskFactorDataType = (riskFactorType) => {
    let item = [];
    riskFactorType.riskFactorScores.forEach(element => {
        if(riskFactorType.riskFactorDataType === 'Alphanumeric') {
            const tempItem = {
                key: element.factorName,
                value: element.score
            }
            item.push(tempItem);
        } else {
            const tempItem = {
                key: element.minFactorValue + ' : ' + element.maxFactorValue,
                value: element.score
            }
            item.push(tempItem);
        }
    })
       /*  if (riskFactorType.riskFactorDataType === 'Alphanumeric') {
            for (let i = 0; i < this.state.data.riskFactorScores.length; i++) {
                const tempItem = {
                    key: riskFactorType.riskFactorScores[i].factorName,
                    value: riskFactorType.riskFactorScores[i].score
                }
                item.push(tempItem);
            }
        } else {
            for (let i = 0; i < riskFactorType.riskFactorScores.length; i++) {
                const tempItem = {
                    key: riskFactorType.riskFactorScores[i].minFactorValue + '-' + riskFactorType.riskFactorScores[i].maxFactorValue,
                    value: riskFactorType.riskFactorScores[i].score
                }
                item.push(tempItem);
            }
        } */
        return item;
}